/* Core by Chloe Pilates — Find your pair, Know your sock */
(function(){
  if (window.__cbcInteract) return; window.__cbcInteract = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');

  async function addToBag(items, activeEl){
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = {items};
    if (cart && typeof cart.getSectionsToRender === 'function'){
      body.sections = cart.getSectionsToRender().map(s => s.id).join(',');
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(activeEl);
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'That pair could not be added.');
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cbc-finder', cartData: data});
    if (data.items && data.items.length && !data.key){ const last = data.items[data.items.length - 1]; data.key = last.key; data.id = last.variant_id; }
    if (cart && typeof cart.renderContents === 'function' && data.sections){ cart.classList.remove('is-empty'); cart.renderContents(data); }
    else window.location = (window.routes && window.routes.cart_url) || '/cart';
  }

  // how each answer leans towards each design, and a line for each taken from its description
  const SCORE = {
    black:   {'midnight-core-grip-sock': 3, 'lucky-ace-grip-sock': 1},
    neutral: {'butter-core-grip-sock': 3, 'vanilla-core-grip-sock': 1},
    white:   {'vanilla-core-grip-sock': 3, 'western-martini-grip-socks': 1, 'after-hours-grip-sock': 1},
    colour:  {'western-martini-grip-socks': 2, 'lucky-ace-grip-sock': 2, 'after-hours-grip-sock': 1},
    quiet:   {'midnight-core-grip-sock': 2, 'vanilla-core-grip-sock': 2, 'butter-core-grip-sock': 2},
    loud:    {'after-hours-grip-sock': 2, 'western-martini-grip-socks': 2, 'lucky-ace-grip-sock': 2},
    early:   {'vanilla-core-grip-sock': 1, 'midnight-core-grip-sock': 1, 'butter-core-grip-sock': 1},
    after:   {'after-hours-grip-sock': 3},
    weekend: {'western-martini-grip-socks': 1, 'lucky-ace-grip-sock': 1, 'butter-core-grip-sock': 1}
  };
  const LINES = {
    'vanilla-core-grip-sock': 'Crisp white, signature red star grips and the embroidered CC star. Simple, timeless and made for your next move.',
    'midnight-core-grip-sock': 'The effortless staple: black, with signature red star grips and CC detailing that goes with everything.',
    'butter-core-grip-sock': "The neutral you didn't know you were missing, somewhere between soft beige and creamy butter.",
    'after-hours-grip-sock': 'Made for the class straight after work and whatever comes next. Martini, lips and CC, all embroidered.',
    'western-martini-grip-socks': 'Western charm for the studio: a red frill cuff, western detailing and red grips. The sock you design your outfit around.',
    'lucky-ace-grip-sock': 'The wildcard. Rich burgundy, a white frill cuff and our Make Your Own Luck playing-card detail.'
  };
  const ORDER = ['midnight-core-grip-sock', 'vanilla-core-grip-sock', 'butter-core-grip-sock', 'after-hours-grip-sock', 'western-martini-grip-socks', 'lucky-ace-grip-sock'];
  const esc = (s) => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));

  if (!customElements.get('cbc-finder')){
    customElements.define('cbc-finder', class extends HTMLElement {
      connectedCallback(){
        if (this._init) return; this._init = true;
        try { this.products = JSON.parse(this.querySelector('[data-products]').textContent).filter(p => p.available); } catch (e) { this.products = []; }
        this.off = parseInt(this.dataset.off, 10) || 0;
        this.qs = Array.from(this.querySelectorAll('[data-q]'));
        this.result = this.querySelector('[data-result]');
        this.back = this.querySelector('[data-back]');
        this.count = this.querySelector('[data-count]');
        this.bar = this.querySelector('[data-bar]');
        this.cc = this.querySelector('.cbf-progress__cc .cbc-cc');
        this.live = this.querySelector('[data-live]');
        this.btn = this.querySelector('[data-add]');
        this.err = this.querySelector('[data-error]');
        this.answers = []; this.step = 0; this.turns = 0;
        this.qs.forEach((q, i) => q.querySelectorAll('.cbf-opt').forEach(b => b.addEventListener('click', () => this.answer(i, b))));
        this.back.addEventListener('click', () => this.go(Math.max(0, this.step - 1)));
        this.querySelector('[data-again]').addEventListener('click', () => { this.answers = []; this.qs.forEach(q => q.querySelectorAll('.cbf-opt').forEach(b => b.classList.remove('is-picked'))); this.go(0); });
        this.btn.addEventListener('click', () => this.add());
        this.go(0, true);
      }
      answer(i, b){
        this.answers[i] = b.dataset.a;
        this.qs[i].querySelectorAll('.cbf-opt').forEach(x => x.classList.toggle('is-picked', x === b));
        setTimeout(() => this.go(i + 1), reduce ? 0 : 260);
      }
      go(step, quiet){
        this.step = step;
        const total = this.qs.length, done = step >= total;
        this.qs.forEach((q, i) => { q.hidden = i !== step; });
        this.result.hidden = !done;
        this.back.hidden = step === 0 || done;
        this.count.textContent = done ? 'Your pair' : String(step + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
        this.bar.style.setProperty('--w', (done ? 100 : (step / total) * 100) + '%');
        if (!quiet && !reduce && this.cc){ this.turns++; this.cc.style.transform = 'rotateY(' + (this.turns * 360) + 'deg)'; }
        if (done) this.showResult();
        else if (!quiet){ const t = this.qs[step].querySelector('.cbf-q__t'); this.live.textContent = t ? t.textContent : ''; }
        if (!quiet){ const r = this.getBoundingClientRect(); if (r.top < -40) this.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'start'}); }
      }
      pick(){
        const score = {};
        this.products.forEach(p => { score[p.handle] = 0; });
        this.answers.forEach(a => { const s = SCORE[a] || {}; Object.keys(s).forEach(h => { if (h in score) score[h] += s[h]; }); });
        const rank = (h) => { const i = ORDER.indexOf(h); return i < 0 ? 99 : i; };
        const sorted = this.products.slice().sort((a, b) => (score[b.handle] - score[a.handle]) || (rank(a.handle) - rank(b.handle)));
        return sorted.slice(0, 2);
      }
      card(p, role){
        const line = LINES[p.handle] || '';
        return '<a class="cbf-card__media" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy">' : '') + (p.tag ? '<span class="cbf-card__tag">' + esc(p.tag) + '</span>' : '') + '</a>' +
          '<p class="cbf-card__role">' + role + '</p><p class="cbf-card__name">' + esc(p.name) + '</p>' + (line ? '<p class="cbf-card__line">' + esc(line) + '</p>' : '') +
          '<a class="cbf-card__link" href="' + esc(p.url) + '">View ' + esc(p.name) + '</a>';
      }
      showResult(){
        this.pair = this.pick();
        const cards = this.result.querySelectorAll('[data-card]');
        if (this.pair.length < 2){ this.result.querySelector('.cbf-pair').hidden = true; return; }
        cards[0].innerHTML = this.card(this.pair[0], 'Your match');
        cards[1].innerHTML = this.card(this.pair[1], 'Pairs well with');
        const sum = this.pair[0].price + this.pair[1].price, deal = Math.max(0, sum - this.off);
        this.result.querySelector('[data-was]').textContent = deal < sum ? money(sum) : '';
        this.result.querySelector('[data-total]').textContent = money(deal);
        this.err.hidden = true;
        this.live.textContent = 'Your match is ' + this.pair[0].name + ', paired with ' + this.pair[1].name + '. Both for ' + money(deal) + '.';
      }
      async add(){
        if (!this.pair || this.pair.length < 2 || this.busy) return;
        this.busy = true; this.btn.disabled = true;
        const label = this.btn.firstElementChild, was = label.textContent; label.textContent = 'Adding…';
        try { await addToBag([{id: this.pair[0].variant, quantity: 1}, {id: this.pair[1].variant, quantity: 1}], this.btn); }
        catch (e) { this.err.textContent = e.message || 'Something went wrong. Please try again.'; this.err.hidden = false; }
        finally { this.busy = false; this.btn.disabled = false; label.textContent = was; }
      }
    });
  }

  if (!customElements.get('cbc-know')){
    customElements.define('cbc-know', class extends HTMLElement {
      connectedCallback(){
        if (this._init) return; this._init = true;
        // tabs
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.ink = this.querySelector('.cbk-tabs__ink');
        this.tabs.forEach((t, i) => {
          t.addEventListener('click', () => this.select(i));
          t.addEventListener('keydown', e => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft'){ e.preventDefault(); const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length; this.select(n); this.tabs[n].focus(); }
          });
        });
        window.addEventListener('resize', () => this.moveInk());
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveInk());
        this.moveInk();
        // fit
        const fit = this.querySelector('[data-fit]');
        if (fit){
          this.sys = 'w';
          this.range = fit.querySelector('[data-size]');
          this.out = fit.querySelector('[data-size-out]');
          this.verdict = fit.querySelector('[data-verdict]');
          this.ask = fit.querySelector('[data-ask]');
          this.band = fit.querySelector('[data-band]');
          this.dot = fit.querySelector('[data-dot]');
          this.scale = fit.querySelector('.cbk-scale');
          fit.querySelectorAll('[data-sys]').forEach(b => b.addEventListener('click', () => {
            if (b.dataset.sys === this.sys) return;
            // keep roughly the same foot when switching (AU women's is about 1.5 sizes above men's)
            const v = parseFloat(this.range.value);
            this.sys = b.dataset.sys;
            fit.querySelectorAll('[data-sys]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
            this.range.value = String(Math.min(15, Math.max(3, this.sys === 'm' ? v - 1.5 : v + 1.5)));
            this.fit();
          }));
          this.range.addEventListener('input', () => this.fit());
          this.fit();
        }
        // care cards
        this.querySelectorAll('.cbk-card').forEach(c => c.addEventListener('click', () => c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true'))));
        // where to wear
        const line = this.querySelector('[data-wear]');
        const chips = Array.from(this.querySelectorAll('.cbk-chip'));
        chips.forEach(c => c.addEventListener('click', () => {
          chips.forEach(x => x.setAttribute('aria-pressed', String(x === c)));
          if (line){ line.textContent = c.dataset.line; line.classList.remove('is-swap'); void line.offsetWidth; line.classList.add('is-swap'); }
        }));
      }
      select(i){
        this.tabs.forEach((t, k) => {
          const on = k === i;
          t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          const p = this.querySelector('#' + t.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
        this.moveInk();
      }
      moveInk(){
        const t = this.tabs.find(x => x.getAttribute('aria-selected') === 'true'); if (!t || !this.ink) return;
        this.ink.style.setProperty('--x', t.offsetLeft + 'px'); this.ink.style.setProperty('--w', t.offsetWidth + 'px');
      }
      fit(){
        const v = parseFloat(this.range.value);
        const lo = this.sys === 'w' ? 5 : 3.5, hi = this.sys === 'w' ? 14.5 : 13;
        const min = parseFloat(this.range.min), max = parseFloat(this.range.max), pct = (x) => ((x - min) / (max - min)) * 100;
        const label = (this.sys === 'w' ? "AU Women's " : "AU Men's ") + (v % 1 ? v.toFixed(1) : v);
        this.out.textContent = label;
        this.range.setAttribute('aria-valuetext', label);
        this.band.style.setProperty('--a', pct(lo) + '%'); this.band.style.setProperty('--b', (pct(hi) - pct(lo)) + '%');
        this.dot.style.setProperty('--d', pct(v) + '%');
        const inside = v >= lo && v <= hi;
        this.verdict.textContent = inside ? 'One size fits you.' : 'Just outside our tested range.';
        this.verdict.classList.toggle('is-out', !inside);
        this.ask.hidden = inside;
      }
    });
  }
})();
